import styled from "@emotion/styled";

import { theme, transientOptions } from "shared/lib/styles";

import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";
import { HeaderOnelineMenuContainer } from "scmp-app/components/header/header-oneline-menu-container";
import { Container as HeaderOnelineMenuStyleContainer } from "scmp-app/components/header/header-oneline-menu-container/header-oneline-menu/header-oneline-menu-style/styles";

type StyledHeaderOnelineMenuContainerProps = ResponsiveStyledProps & {
  $isShowFullList?: boolean;
};

export const StyledHeaderOnelineMenuContainer = styled(HeaderOnelineMenuContainer, {
  ...transientOptions,
})<StyledHeaderOnelineMenuContainerProps>`
  ${theme.breakpoints.up("desktop")} {
    margin-inline: ${({ $isShowFullList = true }) => ($isShowFullList ? "20px" : "0")};
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    ${HeaderOnelineMenuStyleContainer} {
      margin-inline-start: 20px;
    }
  }

  ${responsiveStyles}
`;
